"use strict";
/**
 * Represents either an inputted or suggested item
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Listing = void 0;
var common_1 = require("../common");
var Listing = /** @class */ (function (_super) {
    __extends(Listing, _super);
    function Listing() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Listing.bestAnalysis = function (analysis) {
        if (analysis.length === 0) {
            throw new Error('No analysis found');
        }
        analysis
            .sort(function (a, b) { return b.match - a.match; });
        return analysis[0];
    };
    Listing.defaultProps = function (type, analysis) {
        return {
            type: type,
            offers: analysis,
            bestOffer: this.bestAnalysis(analysis),
            lastUpdate: new Date().toISOString(),
            refreshRequired: true,
            searched: null,
            owned: null,
            ranking: null
        };
    };
    return Listing;
}(common_1.AbstractModelLight));
exports.Listing = Listing;
